var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 12.418c-1.335 5.362-6.764 8.617-12.119 7.283C2.225 18.376-1.038 12.936.3 7.587 1.632 2.227 7.064-1.036 12.416.3c5.36 1.338 8.622 6.762 7.284 12.123v-.004zm-5.291-3.844c.198-1.325-.815-2.04-2.202-2.523l.45-1.794-1.097-.277-.436 1.758c-.287-.075-.586-.14-.886-.208l.437-1.774-1.1-.273-.45 1.803-.7-.166-1.51-.378-.294 1.176s.815.185.795.195c.447.114.527.403.515.638L6.7 11.685c-.062.138-.202.34-.511.261.01.016-.8-.198-.8-.198l-.551 1.256 1.426.355.775.202-.453 1.827 1.1.27.454-1.807c.299.085.585.159.872.228l-.423 1.793 1.1.277.453-1.826c1.869.355 3.276.215 3.868-1.478.476-1.365-.026-2.148-1.012-2.663.71-.163 1.25-.635 1.4-1.608h.01zm-2.511 3.519c-.335 1.367-2.63.625-3.376.44l.602-2.416c.746.192 3.13.56 2.774 1.976zm.343-3.535c-.31 1.243-2.218.615-2.84.458l.547-2.2c.618.15 2.614.436 2.293 1.738v.004z",
    fill: "{props.color}",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinSvgrepoCom);
export default __webpack_public_path__ + "static/media/bitcoin-svgrepo-com.8d44f02c94e97df24ab4cef044893492.svg";
export { ForwardRef as ReactComponent };